<script lang="ts">
    import type {AxiosInstance} from 'axios';

    import CircleModal from 'desktop/templates/circleModal/CircleModal.svelte';
    import SquareModal from 'desktop/templates/squareModal/SquareModal.svelte';
    import SquareExitModal from 'desktop/templates/squareExitModal/SquareExitModal.svelte';
    import SquareExitCartModal from 'desktop/templates/squareExitCartModal/SquareExitModal.svelte';
    import ExpSquareModal from 'desktop/templates/expSquareModal/ExpSquareModal.svelte';
    import SquareProductModal from 'desktop/templates/squareProductModal/SquareProductModal.svelte';
    import SquareAdaExitModal from 'desktop/templates/squareAdaExitModal/SquareAdaExitModal.svelte';
    import SquareExitRecommendations from 'desktop/templates/squareExitRecommendations/SquareExitRecommendations.svelte';
    import SquareDesktopCommon from 'desktop/templates/squareCommonModal/SquareCommonModal.svelte';
    import SquareExitModalRedesign from 'desktop/templates/squareExitModalRedesign/SquareExitModalRedesign.svelte';

    import {TEMPLATE} from 'general/constants';
    import {dyData, modal} from 'general/store';

    import s from './style.module.css';

    export let instance: AxiosInstance;
    export let instanceDY: AxiosInstance;

    const OPTIONS = {
        [TEMPLATE.CIRCLE]: CircleModal,
        [TEMPLATE.SQUARE]: SquareModal,
        [TEMPLATE.SQUARE_PRODUCT]: SquareProductModal,
        [TEMPLATE.SQUARE_EXIT]: SquareExitModal,
        [TEMPLATE.SQUARE_EXIT_CART]: SquareExitCartModal,
        [TEMPLATE.EXP_SQUARE]: ExpSquareModal,
        [TEMPLATE.SQUARE_ADA_EXIT]: SquareAdaExitModal,
        [TEMPLATE.SQUARE_EXIT_RECOMMENDATIONS]: SquareExitRecommendations,
        [TEMPLATE.SQUARE_DESKTOP_COMMON]: SquareDesktopCommon,
        [TEMPLATE.SQUARE_EXIT_REDESIGN]: SquareExitModalRedesign,
    } as const;

    const handleKeydown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            modal.close();
        }
    };
</script>

<svelte:window on:keydown={handleKeydown} />

<div class={s.popup}>
    <svelte:component this={OPTIONS[$dyData.template]} {instance} {instanceDY} />
</div>
